<template>
  <div class="bg-white min-h-screen flex flex-col">
    <TSkipLink />
    <RenderTemplateHeader />

    <main id="main" class="flex-1">
      <RenderTemplateBreadcrumb />
      <slot />
    </main>

    <RenderTemplateFooter class="z-0" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~~/modules/template/composables/useTemplateDataComposable'
await useTemplateDataComposable({
  template: 'standard',
})
</script>
